var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ds-button-link-wrapper', { 'ds-mobile-bottom': _vm.mobileBottom }]},[(_vm.link)?[_c('a',_vm._g({class:{
        'ds-button': true,
        'ds-button-primary': _vm.primary,
        'ds-button-red': _vm.red,
        'ds-button-gray': _vm.gray,
        'ds-button-gray-active': _vm.grayActive,
        'ds-button-big': _vm.big,
        'ds-button-small': _vm.small,
        'ds-button-alt': _vm.alt,
        'ds-button-plain': _vm.plain,
        'ds-button-plain-two': _vm.plainTwo,
        'ds-button-link-ico': _vm.linkIco,
        'ds-button-alt-two': _vm.altTwo,
        'ds-button-download': _vm.download
      },style:({
        padding: _vm.padding,
        width: _vm.width,
        color: _vm.getTextColor,
        backgroundColor: _vm.getBackgroundColor
      }),attrs:{"href":_vm.link,"disabled":_vm.disabled,"target":_vm.target}},_vm.$listeners),[(_vm.icon)?_c('Icon',{class:{ 'ds-button-icon': _vm.hasLabel },style:({ marginRight: _vm.spaceBetween }),attrs:{"source":_vm.icon,"size":_vm.computedIconSize,"color":_vm.getIconColor}}):_vm._e(),_vm._t("default"),(_vm.iconRight)?_c('Icon',{staticClass:"ds-button-icon",style:({ marginLeft: _vm.spaceBetween }),attrs:{"source":_vm.iconRight,"size":_vm.computedIconSize,"color":_vm.getIconColor}}):_vm._e()],2)]:[_c('button',_vm._g({class:{
        'ds-button': true,
        'ds-button-primary': _vm.primary,
        'ds-button-red': _vm.red,
        'ds-button-gray': _vm.gray,
        'ds-button-gray-active': _vm.grayActive,
        'ds-button-big': _vm.big,
        'ds-button-small': _vm.small,
        'ds-button-alt': _vm.alt,
        'ds-button-plain': _vm.plain,
        'ds-button-plain-two': _vm.plainTwo,
        'ds-button-alt-two': _vm.altTwo,
        'ds-button-download': _vm.download
      },style:({
        padding: _vm.padding,
        width: _vm.width,
        color: _vm.getTextColor,
        backgroundColor: _vm.getBackgroundColor
      }),attrs:{"disabled":_vm.disabled}},_vm.$listeners),[(_vm.icon)?_c('Icon',{class:{ 'ds-button-icon': _vm.hasLabel },style:({ marginRight: _vm.spaceBetween }),attrs:{"source":_vm.icon,"size":_vm.computedIconSize,"color":_vm.getIconColor}}):_vm._e(),_vm._t("default"),(_vm.iconRight)?_c('Icon',{staticClass:"ds-button-icon",style:({ marginLeft: _vm.spaceBetween }),attrs:{"source":_vm.iconRight,"size":_vm.computedIconSize,"color":_vm.getIconColor}}):_vm._e()],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }